export default function DocsExceptionsModule() {
  return (
    <section data-docs-section="exceptions" className="text-left mb-16">
      <h2 className="text-2xl font-bold text-white mb-2 group">
        <a href="#exceptions" className="hover:text-sky-400 transition-colors">Exceptions</a>
        <span className="ml-2 opacity-0 group-hover:opacity-100 text-gray-600 transition-opacity">#</span>
      </h2>
      <p className="text-gray-400 mb-6">
        All exceptions inherit from <code className="text-gray-300">PropAlgosError</code> — catch
        broadly or narrowly. Each carries a <code className="text-gray-300">message</code> (str)
        and an optional <code className="text-gray-300">code</code> (str) for programmatic handling.
      </p>

      {/* Hierarchy diagram */}
      <div className="font-mono text-sm bg-gray-900/50 border border-gray-800 rounded-lg p-4 mb-6 text-gray-300 overflow-x-auto text-left">
        <pre className="text-left">{`PropAlgosError (message, code)
├── AuthenticationError         code="auth_error"
├── APIError                    code="api_error"
│   └── status_code, response_body
├── InsufficientCreditsError    code="insufficient_credits"
│   └── balance, required
├── DataError                   code="data_error"
├── BacktestError               code="backtest_error"
└── ConfigError                 code="config_error"`}</pre>
      </div>

      <div className="overflow-x-auto">
        <table className="text-sm text-left w-full">
          <thead>
            <tr className="border-b border-gray-800">
              <th className="py-2 pr-4 text-gray-400 font-medium">Exception</th>
              <th className="py-2 pr-4 text-gray-400 font-medium">Extra Fields</th>
              <th className="py-2 text-gray-400 font-medium">Raised When</th>
            </tr>
          </thead>
          <tbody className="text-gray-300">
            <tr className="border-b border-gray-800/50">
              <td className="py-2 pr-4 font-mono text-sky-400">PropAlgosError</td>
              <td className="py-2 pr-4 text-gray-500">message, code</td>
              <td className="py-2 text-gray-400">Base class — catch this to handle all SDK errors.</td>
            </tr>
            <tr className="border-b border-gray-800/50">
              <td className="py-2 pr-4 font-mono text-sky-400">AuthenticationError</td>
              <td className="py-2 pr-4 text-gray-500">—</td>
              <td className="py-2 text-gray-400">Authentication fails or tokens are invalid/expired.</td>
            </tr>
            <tr className="border-b border-gray-800/50">
              <td className="py-2 pr-4 font-mono text-sky-400">APIError</td>
              <td className="py-2 pr-4 text-gray-500 font-mono text-xs">status_code, response_body</td>
              <td className="py-2 text-gray-400">PropAlgos API call returns an error response.</td>
            </tr>
            <tr className="border-b border-gray-800/50">
              <td className="py-2 pr-4 font-mono text-sky-400">InsufficientCreditsError</td>
              <td className="py-2 pr-4 text-gray-500 font-mono text-xs">balance, required</td>
              <td className="py-2 text-gray-400">Account balance is too low for the operation.</td>
            </tr>
            <tr className="border-b border-gray-800/50">
              <td className="py-2 pr-4 font-mono text-sky-400">DataError</td>
              <td className="py-2 pr-4 text-gray-500">—</td>
              <td className="py-2 text-gray-400">Data retrieval or validation fails (empty results, missing columns).</td>
            </tr>
            <tr className="border-b border-gray-800/50">
              <td className="py-2 pr-4 font-mono text-sky-400">BacktestError</td>
              <td className="py-2 pr-4 text-gray-500">—</td>
              <td className="py-2 text-gray-400">Backtest encounters an unrecoverable issue.</td>
            </tr>
            <tr>
              <td className="py-2 pr-4 font-mono text-sky-400">ConfigError</td>
              <td className="py-2 pr-4 text-gray-500">—</td>
              <td className="py-2 text-gray-400">Configuration is missing or invalid.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
}
